import {isNotNil} from 'ramda-adjunct';

import {VehicleMileageResponseBody} from '@dms/api/sales';
import {FullVehicleResponseBody} from '@dms/api/shared';

import {Nullish} from 'shared/web';

export function getEffectiveMileage(
  latestMileageRecord: Pick<VehicleMileageResponseBody, 'mileage'> | Nullish,
  vehicleData: Pick<FullVehicleResponseBody['vehicle'], 'lastServiceMileage' | 'mileage'>
): number | Nullish {
  const fallbackMileages = [vehicleData.lastServiceMileage, vehicleData.mileage].filter(isNotNil);
  const greatestFallbackMileage =
    fallbackMileages.length > 0 ? Math.max(...fallbackMileages) : null;

  return latestMileageRecord?.mileage ?? greatestFallbackMileage;
}
